import { type ReactNode } from "react";

import { FlexBody } from "./FlexBody";
import { GridBody } from "./GridBody";
import { ResizableContext } from "./ResizableContext";

interface ShellBodyProps {
  children: ReactNode;
  resizable?: boolean;
}

export const ShellBody = ({
  children,
  resizable = true,
}: Readonly<ShellBodyProps>) => (
  <ResizableContext.Provider value={resizable}>
    {resizable ? (
      <FlexBody>{children}</FlexBody>
    ) : (
      <GridBody>{children}</GridBody>
    )}
  </ResizableContext.Provider>
);

ShellBody.displayName = "CircleAIAppShell.Layout.ShellBody";
